import React from "react";
import tableStyles from "../styles/tableStyles";

/**
 * MatrixRow
 *
 * Memoized single row for the beat-target matrix table.
 * Uses native <tr>/<td> and plain <input> for maximum render performance.
 *
 * Props:
 *  - row                   {object}   Single beat row with beatListData array
 *  - index                 {number}   1-based serial number
 *  - onTextFieldDataChange {Function} Curried: (monthName, beatId) => (event) => void
 */
const MatrixRow = React.memo(({ row, index, onTextFieldDataChange }) => (
    <tr>
        <td style={tableStyles.tdCenter}>{index}</td>
        <td style={tableStyles.td}>{row.beatName}</td>

        {row.beatListData.map((monthData) => (
            <td key={monthData.name} style={tableStyles.td}>
                <input
                    inputMode="decimal"
                    style={tableStyles.input}
                    placeholder="Target"
                    value={monthData.target}
                    onChange={(e) => {
                        const val = e.target.value;
                        if (!val || /^\d*\.?\d*$/.test(val)) {
                            onTextFieldDataChange(monthData.name, row.id)(e);
                        }
                    }}
                    className="customTextfield"
                />
            </td>
        ))}

        <td style={tableStyles.tdRight}>{row.totalTarget}</td>
    </tr>
));

MatrixRow.displayName = "MatrixRow";

export default MatrixRow;
